var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileappsAmico(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-16"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-16",
    cx: 250.91,
    cy: 389.59,
    rx: 170.89,
    ry: 92.98,
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.82,393.31c-.44.59-.89,1.12-1.31,1.58-3.93,4.34-10,5.7-15.69,5s-10.66-3.08-15.7-5.44c-.87-.41-1.88-1-1.86-2,0-1.34,1.85-1.69,2.83-2.6-3.35-2-7.59-1.83-11-3.65a10.86,10.86,0,0,1-5.6-8.41,6.43,6.43,0,0,1,.37-3.11c1.25-3,5-3.75,8.22-4.13-5.8-5.58-10.77-13-10.11-21,.23-2.73,1.34-5.68,3.81-6.89s5.54-.23,7.61,1.57,3.37,4.3,4.74,6.67c.21.35.45.73.84.82a1.75,1.75,0,0,0,1.18-.34c2.68-1.44,6.16-.73,8.54,1.17a14.55,14.55,0,0,1,4.57,7.73c.65-1.64,3-2.1,4.51-1.22a6.21,6.21,0,0,1,2.69,4.37c.34,1.73.3,3.52.62,5.25,1.11,6,6.26,10.35,11.5,13.44C227,384.73,224.44,389.9,221.82,393.31Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.82,393.31c-.44.59-.89,1.12-1.31,1.58-3.93,4.34-10,5.7-15.69,5s-10.66-3.08-15.7-5.44c-.87-.41-1.88-1-1.86-2,0-1.34,1.85-1.69,2.83-2.6-3.35-2-7.59-1.83-11-3.65a10.86,10.86,0,0,1-5.6-8.41,6.43,6.43,0,0,1,.37-3.11c1.25-3,5-3.75,8.22-4.13-5.8-5.58-10.77-13-10.11-21,.23-2.73,1.34-5.68,3.81-6.89s5.54-.23,7.61,1.57,3.37,4.3,4.74,6.67c.21.35.45.73.84.82a1.75,1.75,0,0,0,1.18-.34c2.68-1.44,6.16-.73,8.54,1.17a14.55,14.55,0,0,1,4.57,7.73c.65-1.64,3-2.1,4.51-1.22a6.21,6.21,0,0,1,2.69,4.37c.34,1.73.3,3.52.62,5.25,1.11,6,6.26,10.35,11.5,13.44C227,384.73,224.44,389.9,221.82,393.31Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.24,345.4s1.09,17.4,36.72,41.36",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.13,381.4s5.43,2.52,18.59-2",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.13,357.22s3.9,8.76,2.37,16",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.5,415.47A27.34,27.34,0,0,1,206,423.64c-7.7,3-12.05,0-12.05,0s1.51-8.17,5.59-11.25A45.41,45.41,0,0,0,187,421s-4.86,1.13-8.41-5.88c0,0,1.91-5.1,11.06-9.63,0,0-6.21-.2-14.22,3.82-.59.39-5.39-8.63-7.18-12.89s0-4.59,3.26-6.27,14.9-4.82,17.48-3.39,5.09,7.69,5.09,7.69a32.23,32.23,0,0,0-1.48-7.88,26.75,26.75,0,0,1,8.94-.85c4.17.51,4.34,2.46,4.95,5.28a30.5,30.5,0,0,1,.67,8.67s2.18-2.9.41-11.48c0,0,6.23,3.35,9.18,6.75S221.31,408.6,217.5,415.47Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.6,415.91a.51.51,0,0,1-.46-.16c-12.06-11.21-36.66-22.3-45.6-22.1a.46.46,0,0,1,0-.92c9.09-.2,34.24,10.45,46.34,22.45a.45.45,0,0,1-.08.65A.42.42,0,0,1,217.6,415.91Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.5,399.69c4.41-8,11.07-16.8,26.11-25.6s18.52-16.79,14.24-22.93-22.23-4.07-34.22,12.66c-11.58,16.16-12.81,35.47-12.81,35.47Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.5,399.69c4.41-8,11.07-16.8,26.11-25.6s18.52-16.79,14.24-22.93-22.23-4.07-34.22,12.66c-11.58,16.16-12.81,35.47-12.81,35.47Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,353.56s-13.86,1.68-25.31,15.71c-9.92,12.15-14.36,30.17-14.36,30.17",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.8640939999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.9,415.44c7.46,6.15,20.81,9.61,27.22.3,1.38-2,2.34-4.46,4.42-5.72a11.59,11.59,0,0,1,3.81-1.18,20.16,20.16,0,0,0,8-2.94c2.33-1.68,4-4.52,3.59-7.36-.32-2-1.49-3.89-1-6s2-4.24,2.48-6.53c1-4.39-1.71-11.23-7.32-9.31a12.07,12.07,0,0,0-4.81,3.68c-3.27,3.66-5.45,1.54-9.63.82a6.39,6.39,0,0,0-6.92,4.16c-.45,1.38-.46,3-1.43,4-1.33,1.48-3.67,1.17-5.66,1.08a17,17,0,0,0-12.7,5,16.63,16.63,0,0,0-4.75,11.76C316.31,410.36,318.77,413.24,320.9,415.44Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.5,412.7h.06c32.62-1.22,47-28.61,48.09-32.71a.49.49,0,1,0-1-.24c-1,4-15.15,30.77-47.17,32a.5.5,0,0,0,0,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.78,402.41a37.6,37.6,0,0,0,6.13-.09.49.49,0,1,0-.11-1,34.77,34.77,0,0,1-11.16-.76.51.51,0,0,0-.62.34.5.5,0,0,0,.35.61A26.75,26.75,0,0,0,354.78,402.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.91,404.72H345a.51.51,0,0,0,.42-.57,39.87,39.87,0,0,1,.19-13.47.5.5,0,0,0-.37-.6.49.49,0,0,0-.59.37,39.86,39.86,0,0,0-.21,13.85A.48.48,0,0,0,344.91,404.72Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.16,385.46c-.76,14.84-.7,14.22-.66,20.79,0,1.43,0,3.19,0,5.53a0,0,0,0,1,0,0c-1,6.87-6.13,13.58-15.24,18.84-20.6,11.89-54,11.89-74.6,0-10.62-6.13-15.76-14.23-15.42-22.26v-.06c.06-.68.13-1.39.22-2.13,0,0,0-.06,0-.08.89-7.81,3-18.73,3.43-26.06.7-11.63.71-14.22.71-20.48,0-7.08-2.33-13.22-10.48-20.07s-24.35-30.28-24.35-30.28L293.25,254l30.55,96.76S323.27,363.83,322.16,385.46Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.1,
    cy: 241.03,
    r: 15.55,
    transform: "translate(-13.45 465.07) rotate(-76.72)",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.64,329.49l60.88-35.14c2.06,19.72,13.54,29.69,13.54,29.69L277,286l-12.19-7-70.76,40.86C196.42,322.94,199.06,326.36,201.64,329.49Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.62,52.57l-94.8,54.73a7.63,7.63,0,0,0-3.45,6v213.8c0,2.19,1.55,3.09,3.45,2l94.8-54.73a7.64,7.64,0,0,0,3.44-6V54.56C292.06,52.36,290.52,51.47,288.62,52.57ZM287.1,248.65c0,1.88-1.32,3.08-3,4L198,302.44c-1.63.94-3,.18-3-1.71V133.25a6.56,6.56,0,0,1,3-5.12l86.2-49.76c1.63-1,3-.18,3,1.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.39,329.27a7.73,7.73,0,0,1-6.47-.21L183,326.78a7.59,7.59,0,0,1-3.45-6V107a6.57,6.57,0,0,1,.59-2.57,8,8,0,0,1,.41-.83,0,0,0,0,0,0,0l10.85,6.26h0a9.17,9.17,0,0,0-.6,1.27,6.34,6.34,0,0,0-.42,2.13v213.8C190.37,329.09,191.69,330,193.39,329.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,282.9c3-1.73,5.44-.32,5.44,3.15a12,12,0,0,1-5.44,9.42c-3,1.74-5.45.33-5.45-3.14A12,12,0,0,1,242,282.9Z",
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeMiterlimit: 10
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M241.22,84.54c1.27-.73,2.31-.14,2.31,1.34a5.13,5.13,0,0,1-2.31,4c-1.28.74-2.31.14-2.31-1.33A5.11,5.11,0,0,1,241.22,84.54Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M232.3,98.6l17.84-10.3c1.06-.62,1.93-.18,1.93,1a4.1,4.1,0,0,1-1.93,3.2L232.3,102.78c-1.07.61-1.93.18-1.93-1A4.13,4.13,0,0,1,232.3,98.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M287.1,248.48c0,1.88-1.32,3.08-3,4L198,302.26c-1.63.94-3,.18-3-1.71V133.08a6.57,6.57,0,0,1,3-5.13l86.2-49.75c1.63-1,3-.18,3,1.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,54c-.25-1.79-1.68-2.44-3.41-1.44L193.81,107.3a7,7,0,0,0-2.43,2.57l-10.85-6.26a6.93,6.93,0,0,1,2.44-2.56l94.8-54.74a7.61,7.61,0,0,1,6.89,0l4,2.27A7.75,7.75,0,0,1,292,54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.78,135.22V134a.77.77,0,0,1,.24-.61l.06,0c.13-.08.24.08.24.34v1.23a.78.78,0,0,1-.24.62l-.06,0C199.89,135.64,199.78,135.49,199.78,135.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.85,134.61v-2.13a.77.77,0,0,1,.24-.61l.06,0c.13-.08.23.08.23.34v2.13a.77.77,0,0,1-.23.61l-.06,0C201,135,200.85,134.87,200.85,134.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.92,134v-3a.77.77,0,0,1,.23-.61l.07,0c.13-.08.23.08.23.34v3a.79.79,0,0,1-.23.62l-.07,0C202,134.41,201.92,134.26,201.92,134Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,133.37v-5.21a.77.77,0,0,1,.23-.61l.07,0c.13-.07.23.08.23.35v5.2a.78.78,0,0,1-.24.62l-.06,0C203.09,133.79,203,133.64,203,133.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.87,132.06s0-.07,0-.16v-.76l-1.19.69c-.07,0-.1,0-.1-.1v-.28a.66.66,0,0,1,0-.15s0-.09,0-.15l1.27-3.47.06-.13a.24.24,0,0,1,.09-.08l.16-.1s.09,0,.11,0a.3.3,0,0,1,0,.17v2.67l.26-.15s.09,0,.11,0a.34.34,0,0,1,0,.17v.18a.47.47,0,0,1,0,.19.25.25,0,0,1-.11.12l-.26.15v.77a.36.36,0,0,1,0,.19.21.21,0,0,1-.11.12l-.2.11S205.9,132.09,205.87,132.06Zm0-1.62v-1.9l-.87,2.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.3,130.78a2.47,2.47,0,0,1-.36-1.56,4.88,4.88,0,0,1,.36-2,2.33,2.33,0,0,1,1-1.19,1.3,1.3,0,0,1,.48-.18.5.5,0,0,1,.37.05.08.08,0,0,1,0,.07.34.34,0,0,1,0,.09l-.11.39s0,.08-.05.09,0,0-.05,0a.7.7,0,0,0-.61.09,1.62,1.62,0,0,0-.67.83,3.56,3.56,0,0,0-.25,1.45,2,2,0,0,0,.24,1.18c.16.19.37.21.65,0a2.73,2.73,0,0,0,.3-.21,1.79,1.79,0,0,0,.23-.26v-1.24l-.5.28c-.05,0-.08,0-.1,0a.32.32,0,0,1,0-.17v-.17a.53.53,0,0,1,0-.2.26.26,0,0,1,.1-.11l.8-.46q.08,0,.12,0a.46.46,0,0,1,0,.2v1.77a.71.71,0,0,1,0,.16.31.31,0,0,1-.05.12,2.54,2.54,0,0,1-.94.93C207.86,131.07,207.53,131.05,207.3,130.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.48,82.66c-.14-.2-.31-.26-.48-.16l-3.58,2.07a1.82,1.82,0,0,0-.55,1.45V88.7a1.51,1.51,0,0,0,.21.85.46.46,0,0,0,.19.18.29.29,0,0,0,.28,0l3.58-2.06a1.83,1.83,0,0,0,.55-1.45V83.51A1.57,1.57,0,0,0,283.48,82.66Zm-4.27,6.55a.8.8,0,0,1-.08-.4V86.13a1.43,1.43,0,0,1,.42-1.1L283.13,83a.16.16,0,0,1,.15,0,.12.12,0,0,1,.07,0,.87.87,0,0,1,.07.39v2.68a1.41,1.41,0,0,1-.42,1.1l-3.58,2.07Q279.28,89.32,279.21,89.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.47,84.4v3.17l-1.93,1.12-.06,0V86.2a1.08,1.08,0,0,1,.31-.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.86,83.42c.13-.07.24.31.24.86v.5a2,2,0,0,1-.24,1.16l-.24.16V83.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.14,126.44a1.84,1.84,0,0,1-.69,1.47c-.39.22-.7-.08-.7-.67a1.83,1.83,0,0,1,.7-1.47C213.83,125.55,214.14,125.85,214.14,126.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.45,124a4.16,4.16,0,0,0-1.62,2.42c-.06.21,0,.42.08.49h0c.13.08.32-.09.4-.36a3,3,0,0,1,1.14-1.72.73.73,0,0,1,1.13.4c.08.19.28.13.41-.1h0a.76.76,0,0,0,.07-.58A1,1,0,0,0,213.45,124Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.45,122.31a6.49,6.49,0,0,0-2.48,3.53c-.08.23-.06.46.06.53h0c.12.08.31-.08.4-.34a5.26,5.26,0,0,1,2-2.89,1.34,1.34,0,0,1,2,.55c.09.16.27.11.4-.12h0a.73.73,0,0,0,.06-.6A1.65,1.65,0,0,0,213.45,122.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.51,113.67a.37.37,0,0,1,0,.14.17.17,0,0,1-.08.1l-.18.11a.08.08,0,0,1-.08,0,.16.16,0,0,1,0-.11v-3.65l-.7,1.22s-.06.08-.09.09a.08.08,0,0,1-.08,0l-.1-.15a.16.16,0,0,1,0-.12.42.42,0,0,1,0-.15l.92-1.62a.3.3,0,0,1,.07-.08l.07,0,.18-.1a.06.06,0,0,1,.08,0,.18.18,0,0,1,0,.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.52,110.13a.07.07,0,0,1,.09,0,.16.16,0,0,1,0,.11v.44a.4.4,0,0,1,0,.15s-.05.08-.09.1l-.29.16a.06.06,0,0,1-.08,0,.18.18,0,0,1,0-.11v-.44a.4.4,0,0,1,0-.15.21.21,0,0,1,.08-.1Zm0,2.33a.07.07,0,0,1,.09,0,.16.16,0,0,1,0,.11V113a.4.4,0,0,1,0,.15.22.22,0,0,1-.09.1l-.29.17a.06.06,0,0,1-.08,0,.16.16,0,0,1,0-.11v-.44a.4.4,0,0,1,0-.15.27.27,0,0,1,.08-.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.64,112a.06.06,0,0,1-.08,0,.16.16,0,0,1,0-.11V111l-1.36.78s0,0-.08,0a.15.15,0,0,1,0-.1v-.24a.52.52,0,0,1,.06-.26l1.36-3.54a.8.8,0,0,1,.08-.16.2.2,0,0,1,.09-.09l.17-.1a.06.06,0,0,1,.08,0,.12.12,0,0,1,0,.11v2.77l.37-.21a.06.06,0,0,1,.08,0,.18.18,0,0,1,0,.11v.24a.4.4,0,0,1,0,.15.27.27,0,0,1-.08.1l-.37.21v.91a.28.28,0,0,1,0,.15.21.21,0,0,1-.08.1Zm-.11-1.62v-1.87l-.94,2.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.14,110.05l.06.17a.3.3,0,0,0,.12.13.33.33,0,0,0,.2,0,1.14,1.14,0,0,0,.34-.13,2.19,2.19,0,0,0,.25-.2,1.21,1.21,0,0,0,.21-.28,1.28,1.28,0,0,0,.14-.34,1.35,1.35,0,0,0,.06-.41,1,1,0,0,0-.05-.33c0-.08-.08-.14-.14-.16a.37.37,0,0,0-.21,0,1.12,1.12,0,0,0-.26.11l-.36.21a.05.05,0,0,1-.08,0,.11.11,0,0,1,0-.1v-.24a.5.5,0,0,1,0-.12l0-.12.78-1.73-1.24.71a.07.07,0,0,1-.09,0,.18.18,0,0,1,0-.11v-.24a.4.4,0,0,1,0-.15.22.22,0,0,1,.09-.1l1.69-1a.1.1,0,0,1,.09,0,.16.16,0,0,1,0,.11V106a.5.5,0,0,1,0,.12.94.94,0,0,1-.06.15L243,108a.92.92,0,0,1,.39-.12.42.42,0,0,1,.31.09.68.68,0,0,1,.2.32,1.81,1.81,0,0,1,.07.52,2.37,2.37,0,0,1-.09.65,2.13,2.13,0,0,1-.23.58,2.08,2.08,0,0,1-.34.48,1.58,1.58,0,0,1-.41.34,1.31,1.31,0,0,1-.5.19.5.5,0,0,1-.35-.08.46.46,0,0,1-.2-.25,1.23,1.23,0,0,1-.07-.39.27.27,0,0,1,0-.12.18.18,0,0,1,.06-.08l.2-.12a.06.06,0,0,1,.08,0A.11.11,0,0,1,242.14,110.05Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M224.2,167.39V146a1.92,1.92,0,0,0-.87-1.5l-.23-.13a1.91,1.91,0,0,0-1.74,0l-18.57,10.73a1.91,1.91,0,0,0-.87,1.5V178a1.89,1.89,0,0,0,.87,1.5l.23.14a1.91,1.91,0,0,0,1.74,0l18.57-10.73A1.92,1.92,0,0,0,224.2,167.39Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.33,145.45l-18.57,10.73a1.92,1.92,0,0,0-.87,1.5v21.44c0,.55.39.78.87.5l18.57-10.73a1.92,1.92,0,0,0,.87-1.5V146C224.2,145.4,223.81,145.18,223.33,145.45Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.18,145.79c-.06-.43-.42-.59-.85-.34l-18.57,10.73a1.9,1.9,0,0,0-.62.64l-2-1.13a1.64,1.64,0,0,1,.61-.64l18.57-10.74a2,2,0,0,1,1.74,0l.23.14A1.94,1.94,0,0,1,224.18,145.79Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.56,179.71a1.89,1.89,0,0,1-1.53-.09l-.24-.13a1.92,1.92,0,0,1-.87-1.5V156.55a1.75,1.75,0,0,1,.26-.86l2,1.13a1.85,1.85,0,0,0-.25.86v21.44C203.89,179.6,204.17,179.83,204.56,179.71Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,159.4a7.5,7.5,0,0,0-3.13,6c0,2.3,1.41,3.36,3.13,2.36a7.5,7.5,0,0,0,3.13-6C217.17,159.46,215.77,158.4,214,159.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.09 159.86 209.5 159.05 209.5 159.76 208.09 160.57 208.09 159.86",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.57,154l-2.67,1.54c-.5.29-.91,0-.91-.7s-.41-1-.92-.69l-4,2.34a2.17,2.17,0,0,0-.92,1.75,2.21,2.21,0,0,1-.91,1.75l-2.67,1.54a2.19,2.19,0,0,0-.91,1.75v10.16c0,.68.41,1,.91.7l13-7.54a2.19,2.19,0,0,0,.91-1.75V154.64C221.48,154,221.07,153.65,220.57,154ZM214,168.76c-2.14,1.24-3.89-.08-3.89-2.94s1.75-6.2,3.89-7.44,3.9.08,3.9,2.94S216.19,167.52,214,168.76Zm4-10.66c-.28.16-.5,0-.5-.38a1.19,1.19,0,0,1,.5-1c.27-.16.5,0,.5.38A1.22,1.22,0,0,1,218.06,158.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.2,233V211.59a1.92,1.92,0,0,0-.87-1.5l-.23-.13a1.91,1.91,0,0,0-1.74,0l-18.57,10.73a1.89,1.89,0,0,0-.87,1.5v21.43a1.91,1.91,0,0,0,.87,1.5l.23.14a2,2,0,0,0,1.74,0l18.57-10.73A1.92,1.92,0,0,0,224.2,233Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.33,211.09l-18.57,10.73a1.92,1.92,0,0,0-.87,1.5v21.44c0,.55.39.77.87.5l18.57-10.73a1.92,1.92,0,0,0,.87-1.5V211.59C224.2,211,223.81,210.82,223.33,211.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.18,211.43c-.06-.43-.42-.59-.85-.34l-18.57,10.73a1.9,1.9,0,0,0-.62.64l-2-1.13a1.64,1.64,0,0,1,.61-.64L221.36,210a2,2,0,0,1,1.74,0l.23.14A1.94,1.94,0,0,1,224.18,211.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.56,245.34a1.89,1.89,0,0,1-1.53-.09l-.24-.13a1.92,1.92,0,0,1-.87-1.5V222.19a1.75,1.75,0,0,1,.26-.86l2,1.13a1.85,1.85,0,0,0-.25.86v21.43C203.89,245.23,204.17,245.46,204.56,245.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.6,225.9h0a.2.2,0,0,0-.11,0l-1.45-.08a.23.23,0,0,1-.24-.23c0-.23,0-.46,0-.68a4.25,4.25,0,0,0,0-.72.74.74,0,0,1,.16-.43l1.62-1.95a.42.42,0,0,0,.09-.4l-.76-1.7a.12.12,0,0,0,0-.05h0a.25.25,0,0,0-.25.08l-1.72,1.57a.32.32,0,0,1-.38.07,2.39,2.39,0,0,0-.74-.43.28.28,0,0,1-.17-.3l.53-2.42a.15.15,0,0,0-.07-.17.38.38,0,0,0-.16,0l-1.69.17a.49.49,0,0,0-.37.26l-.91,2.45a.81.81,0,0,1-.37.36,7.48,7.48,0,0,0-1,.6c-.15.1-.3.1-.37,0l-.86-1.32c-.06-.09-.2-.07-.31,0l-1.85,2a.52.52,0,0,0-.15.41l.52,1.74a.6.6,0,0,1-.09.42,15.78,15.78,0,0,0-.86,1.48.66.66,0,0,1-.4.3l-1.58.38a.55.55,0,0,0-.36.3l-.8,2.69c0,.12,0,.23.2.24l1.45.08a.23.23,0,0,1,.24.23,7.27,7.27,0,0,0,0,1.4.7.7,0,0,1-.16.43l-1.61,1.95a.44.44,0,0,0-.1.41l.76,1.69a.12.12,0,0,0,0,.05h.07a.3.3,0,0,0,.19-.09l1.72-1.57a.32.32,0,0,1,.38-.07,2.39,2.39,0,0,0,.74.43.27.27,0,0,1,.17.3l-.53,2.42a.13.13,0,0,0,.07.16h0a.38.38,0,0,0,.16,0l1.69-.17a.49.49,0,0,0,.37-.26l.91-2.45a.81.81,0,0,1,.37-.36,4.63,4.63,0,0,0,.54-.28l.5-.32c.14-.1.3-.1.36,0l.87,1.32,0,0a.24.24,0,0,0,.27-.08l1.85-2a.47.47,0,0,0,.14-.41l-.51-1.74a.6.6,0,0,1,.09-.42,13.75,13.75,0,0,0,.85-1.48.71.71,0,0,1,.41-.3l1.58-.38a.53.53,0,0,0,.36-.3l.8-2.68A.2.2,0,0,0,221.6,225.9Zm-8.45,6.56-.1,0H213l-.15,0h-.34a1.69,1.69,0,0,1-1.58-1.07,3.15,3.15,0,0,1-.24-.89,3.85,3.85,0,0,1,0-.49,7.52,7.52,0,0,1,2.09-4.79,5.91,5.91,0,0,1,1.28-1,4.11,4.11,0,0,1,.42-.21,2.74,2.74,0,0,1,1.2-.26h.2a1.7,1.7,0,0,1,1.32,1.05c.72,1.58-.1,4.35-1.83,6.17A4.82,4.82,0,0,1,213.15,232.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.51,230.75h-.39a1,1,0,0,1-1-.64,1.8,1.8,0,0,1-.14-.53c0-.1,0-.2,0-.3a4.52,4.52,0,0,1,1.26-2.87,3.19,3.19,0,0,1,.76-.62l.26-.13a1.5,1.5,0,0,1,.72-.16h.12a1,1,0,0,1,.79.62c.43.95-.06,2.61-1.1,3.7A2.88,2.88,0,0,1,213.51,230.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.07,134.57V113.13a1.89,1.89,0,0,0-.87-1.49l-.23-.14a1.91,1.91,0,0,0-1.74,0l-18.58,10.73a1.94,1.94,0,0,0-.86,1.5v21.43a1.89,1.89,0,0,0,.87,1.5l.23.14a1.89,1.89,0,0,0,1.73,0l18.58-10.73A1.92,1.92,0,0,0,281.07,134.57Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.2,112.63l-18.58,10.73a1.94,1.94,0,0,0-.86,1.5V146.3c0,.55.39.78.86.5l18.58-10.73a1.92,1.92,0,0,0,.87-1.5V113.13C281.07,112.58,280.68,112.36,280.2,112.63Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.2,112.63l-18.58,10.73a1.94,1.94,0,0,0-.86,1.5V146.3c0,.55.39.78.86.5l18.58-10.73a1.92,1.92,0,0,0,.87-1.5V113.13C281.07,112.58,280.68,112.36,280.2,112.63Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.05,113c-.06-.43-.42-.59-.85-.34l-18.57,10.73a1.9,1.9,0,0,0-.62.64l-2-1.13a1.64,1.64,0,0,1,.61-.64l18.57-10.74a2,2,0,0,1,1.74,0l.23.14A1.94,1.94,0,0,1,281.05,113Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.43,146.89a1.89,1.89,0,0,1-1.53-.09l-.24-.13a1.92,1.92,0,0,1-.87-1.5V123.73a1.75,1.75,0,0,1,.26-.86l2,1.13a1.85,1.85,0,0,0-.25.86V146.3C260.76,146.78,261,147,261.43,146.89Z",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.9,128.86l6.65,3.88c.22.12.51-.05.72-.42l6.65-11.55v10.49a1.56,1.56,0,0,1-.59,1.26l-12.83,7.41c-.33.19-.6-.07-.6-.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.56,131.18l-6.66-3.64,14-8.1-6.66,11.33C271.06,131.13,270.77,131.3,270.56,131.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.63,151V129.53a1.91,1.91,0,0,0-.86-1.5l-.24-.14a2,2,0,0,0-1.73,0l-18.58,10.73a1.92,1.92,0,0,0-.87,1.5v21.44a1.91,1.91,0,0,0,.86,1.5l.24.14a2,2,0,0,0,1.73,0l18.58-10.73A1.91,1.91,0,0,0,252.63,151Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.77,129l-18.58,10.73a1.92,1.92,0,0,0-.87,1.5V162.7c0,.55.39.77.87.5l18.58-10.73a1.91,1.91,0,0,0,.86-1.5V129.53C252.63,129,252.25,128.75,251.77,129Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.77,129l-18.58,10.73a1.92,1.92,0,0,0-.87,1.5V162.7c0,.55.39.77.87.5l18.58-10.73a1.91,1.91,0,0,0,.86-1.5V129.53C252.63,129,252.25,128.75,251.77,129Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.61,129.37c-.06-.43-.42-.59-.85-.34l-18.57,10.73a1.9,1.9,0,0,0-.62.64l-2-1.13a1.64,1.64,0,0,1,.61-.64l18.57-10.74a2,2,0,0,1,1.74,0l.23.14A1.94,1.94,0,0,1,252.61,129.37Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,163.28a1.89,1.89,0,0,1-1.53-.09l-.24-.13a1.92,1.92,0,0,1-.87-1.5V140.13a1.75,1.75,0,0,1,.26-.86l2,1.13a1.85,1.85,0,0,0-.25.86v21.43C232.32,163.17,232.6,163.4,233,163.28Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.39,150a14.89,14.89,0,0,0,2.18-7.39c0-4.33-2.61-6.34-5.83-4.48s-5.84,6.89-5.84,11.22,2.62,6.34,5.84,4.48a8.19,8.19,0,0,0,1.57-1.2c.36.61,1.38,1.79,3.41.14C246.72,152.74,245.62,152.2,245.39,150Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.2,200.21V178.77a1.92,1.92,0,0,0-.87-1.5l-.23-.13a1.91,1.91,0,0,0-1.74,0l-18.57,10.73a1.91,1.91,0,0,0-.87,1.5V210.8a1.91,1.91,0,0,0,.87,1.5l.23.14a2,2,0,0,0,1.74,0l18.57-10.73A1.92,1.92,0,0,0,224.2,200.21Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.33,178.27,204.76,189a1.92,1.92,0,0,0-.87,1.5v21.44c0,.55.39.77.87.5l18.57-10.73a1.92,1.92,0,0,0,.87-1.5V178.77C224.2,178.22,223.81,178,223.33,178.27Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.33,178.27,204.76,189a1.92,1.92,0,0,0-.87,1.5v21.44c0,.55.39.77.87.5l18.57-10.73a1.92,1.92,0,0,0,.87-1.5V178.77C224.2,178.22,223.81,178,223.33,178.27Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.18,178.61c-.06-.43-.42-.59-.85-.34L204.76,189a1.9,1.9,0,0,0-.62.64l-2-1.13a1.64,1.64,0,0,1,.61-.64l18.57-10.74a2,2,0,0,1,1.74,0l.23.14A1.94,1.94,0,0,1,224.18,178.61Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.56,212.53a1.89,1.89,0,0,1-1.53-.09l-.24-.13a1.92,1.92,0,0,1-.87-1.5V189.37a1.75,1.75,0,0,1,.26-.86l2,1.13a1.85,1.85,0,0,0-.25.86v21.44C203.89,212.42,204.17,212.65,204.56,212.53Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,197.8a18.56,18.56,0,0,0,1.63-7.72,13.93,13.93,0,0,0,1.33-2.61,9.43,9.43,0,0,1-1.53,1.45,7.19,7.19,0,0,0,1.17-2.65,10.32,10.32,0,0,1-1.69,1.84,1.65,1.65,0,0,0-2,0,6.34,6.34,0,0,0-2.6,5.88c-2.22,1.14-4.19.86-5.51-.54-.7,2-.36,3.91.83,4.28a2,2,0,0,1-1.21.26c0,1.66.85,2.7,2.14,2.3a3.45,3.45,0,0,1-1.21.76,1.57,1.57,0,0,0,2.5,1,9.19,9.19,0,0,1-4,3.76,5.33,5.33,0,0,0,4.1-.76,15.36,15.36,0,0,0,6-7.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.63,183.79V162.35a1.91,1.91,0,0,0-.86-1.5l-.24-.14a2,2,0,0,0-1.73,0l-18.58,10.73a1.92,1.92,0,0,0-.87,1.5v21.44a1.91,1.91,0,0,0,.86,1.5l.24.14a2,2,0,0,0,1.73,0l18.58-10.73A1.91,1.91,0,0,0,252.63,183.79Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.77,161.85l-18.58,10.73a1.92,1.92,0,0,0-.87,1.5v21.44c0,.55.39.77.87.5l18.58-10.73a1.91,1.91,0,0,0,.86-1.5V162.35C252.63,161.8,252.25,161.57,251.77,161.85Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.61,162.19c-.06-.43-.42-.59-.85-.34l-18.57,10.73a1.9,1.9,0,0,0-.62.64l-2-1.13a1.64,1.64,0,0,1,.61-.64l18.57-10.74a2,2,0,0,1,1.74,0l.23.14A1.94,1.94,0,0,1,252.61,162.19Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,196.1a1.89,1.89,0,0,1-1.53-.09l-.24-.13a1.92,1.92,0,0,1-.87-1.5V173a1.75,1.75,0,0,1,.26-.86l2,1.13a1.85,1.85,0,0,0-.25.86v21.43C232.32,196,232.6,196.22,233,196.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.48,172.18c1.65-1,1.85-1.06,2.5-1.4a2.94,2.94,0,0,1,1.14-.38,1.06,1.06,0,0,1,.72.21,1.33,1.33,0,0,1,.46.68,4.81,4.81,0,0,1,.21,1.41c0,.85,0,1.11,0,3.31s0,2.46,0,3.35a8,8,0,0,1-.21,1.65,5.46,5.46,0,0,1-.46,1.22,4.54,4.54,0,0,1-.72,1,5.27,5.27,0,0,1-1.14.95c-.65.42-.85.54-2.5,1.49s-1.85,1.06-2.5,1.39a2.75,2.75,0,0,1-1.15.38,1,1,0,0,1-.71-.2,1.37,1.37,0,0,1-.46-.68,4.88,4.88,0,0,1-.21-1.41c0-.85,0-1.11,0-3.31s0-2.47,0-3.35a8.14,8.14,0,0,1,.21-1.66,5.31,5.31,0,0,1,1.17-2.24,5.39,5.39,0,0,1,1.15-.94c.65-.42.85-.54,2.5-1.49m0-1.49c-1.68,1-1.89,1.1-2.55,1.52a7,7,0,0,0-1.5,1.25,7.19,7.19,0,0,0-1.09,1.58,8,8,0,0,0-.72,1.88,10.15,10.15,0,0,0-.28,2.16c0,.9,0,1.18,0,3.42s0,2.52,0,3.38a6.09,6.09,0,0,0,.28,1.83,2.09,2.09,0,0,0,.72,1,1.55,1.55,0,0,0,1.09.32,3.65,3.65,0,0,0,1.5-.48c.66-.34.87-.46,2.55-1.43s1.89-1.1,2.55-1.52a7.14,7.14,0,0,0,2.59-2.83,8.06,8.06,0,0,0,.72-1.87,10.16,10.16,0,0,0,.28-2.17c0-.89,0-1.18,0-3.42s0-2.51,0-3.37a6.22,6.22,0,0,0-.28-1.84,2.09,2.09,0,0,0-.72-1.05,1.5,1.5,0,0,0-1.09-.31,3.65,3.65,0,0,0-1.5.48c-.66.34-.87.45-2.55,1.42",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.48,174.7a7.61,7.61,0,0,0-3.17,6.07c0,2.33,1.42,3.41,3.17,2.39a7.59,7.59,0,0,0,3.17-6.06c0-2.34-1.42-3.41-3.17-2.4m0,7c-1.14.66-2.06,0-2.06-1.56a4.9,4.9,0,0,1,2.06-3.93c1.14-.66,2.06,0,2.06,1.55a4.93,4.93,0,0,1-2.06,3.94",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.52,172.2a1.78,1.78,0,0,1-.74,1.42c-.41.23-.74,0-.74-.56a1.78,1.78,0,0,1,.74-1.42c.41-.24.74,0,.74.56",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.07,167.39V146a1.92,1.92,0,0,0-.87-1.5l-.23-.13a1.91,1.91,0,0,0-1.74,0l-18.58,10.73a1.92,1.92,0,0,0-.86,1.5V178a1.89,1.89,0,0,0,.87,1.5l.23.14a1.89,1.89,0,0,0,1.73,0l18.58-10.73A1.92,1.92,0,0,0,281.07,167.39Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.2,145.45l-18.58,10.73a1.94,1.94,0,0,0-.86,1.5v21.44c0,.55.39.78.86.5l18.58-10.73a1.92,1.92,0,0,0,.87-1.5V146C281.07,145.4,280.68,145.18,280.2,145.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.05,145.79c-.06-.43-.42-.59-.85-.34l-18.57,10.73a1.9,1.9,0,0,0-.62.64l-2-1.13a1.64,1.64,0,0,1,.61-.64l18.57-10.74a2,2,0,0,1,1.74,0l.23.14A1.94,1.94,0,0,1,281.05,145.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.43,179.71a1.89,1.89,0,0,1-1.53-.09l-.24-.13a1.92,1.92,0,0,1-.87-1.5V156.55a1.75,1.75,0,0,1,.26-.86l2,1.13a1.85,1.85,0,0,0-.25.86v21.44C260.76,179.6,261,179.83,261.43,179.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.87,176.59l3-1.75V164.72L272,163.5l.23-3.52-2.34,1.35V159.4c0-.8.12-1.18.7-1.52l1.64-.94v-3.52l-2.1,1.21a6.15,6.15,0,0,0-3.27,5.75v2.7l-1.58.91v3.43l1.58-.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.63,216.6V195.17a1.91,1.91,0,0,0-.86-1.5l-.24-.14a2,2,0,0,0-1.73,0l-18.58,10.73a1.92,1.92,0,0,0-.87,1.5V227.2a1.91,1.91,0,0,0,.86,1.5l.24.13a1.89,1.89,0,0,0,1.73,0l18.58-10.73A1.88,1.88,0,0,0,252.63,216.6Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.77,194.67,233.19,205.4a1.92,1.92,0,0,0-.87,1.5v21.43c0,.56.39.78.87.5l18.58-10.73a1.88,1.88,0,0,0,.86-1.5V195.17C252.63,194.62,252.25,194.39,251.77,194.67Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.77,194.67,233.19,205.4a1.92,1.92,0,0,0-.87,1.5v21.43c0,.56.39.78.87.5l18.58-10.73a1.88,1.88,0,0,0,.86-1.5V195.17C252.63,194.62,252.25,194.39,251.77,194.67Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.61,195c-.06-.43-.42-.59-.85-.34L233.19,205.4a1.9,1.9,0,0,0-.62.64l-2-1.13a1.64,1.64,0,0,1,.61-.64l18.57-10.74a2,2,0,0,1,1.74,0l.23.14A1.94,1.94,0,0,1,252.61,195Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,228.92a1.89,1.89,0,0,1-1.53-.09l-.24-.13a1.92,1.92,0,0,1-.87-1.5V205.77a1.75,1.75,0,0,1,.26-.86l2,1.13a1.85,1.85,0,0,0-.25.86v21.43C232.32,228.81,232.6,229,233,228.92Z",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.35,206.31V218a4.2,4.2,0,0,0-1,.45,4.73,4.73,0,0,0-2.15,3.72c0,1.37,1,1.92,2.15,1.24a5.81,5.81,0,0,0,2.61-4V208.7l6.89-3.93v8.42a4.61,4.61,0,0,0-1,.45,3.94,3.94,0,0,0-1.75,3.48c0,1.37,1,1.92,2.15,1.23a4.77,4.77,0,0,0,2.15-3.71h0V200.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.2,265.85V244.41a1.92,1.92,0,0,0-.87-1.5l-.23-.13a1.91,1.91,0,0,0-1.74,0l-18.57,10.73a1.89,1.89,0,0,0-.87,1.5v21.43a1.92,1.92,0,0,0,.87,1.5l.23.14a2,2,0,0,0,1.74,0l18.57-10.73A1.92,1.92,0,0,0,224.2,265.85Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.33,243.91l-18.57,10.73a1.92,1.92,0,0,0-.87,1.5v21.44c0,.55.39.77.87.5l18.57-10.73a1.92,1.92,0,0,0,.87-1.5V244.41C224.2,243.86,223.81,243.64,223.33,243.91Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.18,244.25c-.06-.43-.42-.59-.85-.34l-18.57,10.73a1.9,1.9,0,0,0-.62.64l-2-1.13a1.64,1.64,0,0,1,.61-.64l18.57-10.74a2,2,0,0,1,1.74,0l.23.14A1.94,1.94,0,0,1,224.18,244.25Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.56,278.16a1.89,1.89,0,0,1-1.53-.09l-.24-.13a1.92,1.92,0,0,1-.87-1.5V255a1.75,1.75,0,0,1,.26-.86l2,1.13a1.85,1.85,0,0,0-.25.86v21.43C203.89,278.05,204.17,278.28,204.56,278.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.36,257.56V273.3c0,.55.39.77.87.5l13.63-7.87a1.92,1.92,0,0,0,.87-1.5V248.69c0-.55-.39-.77-.87-.5l-13.63,7.87A1.92,1.92,0,0,0,206.36,257.56Zm14.42,4.2-3.35-1.95-1.91,2.51L217,264l-5-3.36-4.76,7.54V257.11l13.47-7.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.56,254.11c.6-.35,1.09-.06,1.09.63a2.41,2.41,0,0,1-1.09,1.89c-.6.35-1.09.07-1.09-.63A2.43,2.43,0,0,1,217.56,254.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.63,249.42V228a1.91,1.91,0,0,0-.86-1.5l-.24-.14a2,2,0,0,0-1.73,0l-18.58,10.73a1.92,1.92,0,0,0-.87,1.5V260a1.91,1.91,0,0,0,.86,1.5l.24.13a1.89,1.89,0,0,0,1.73,0l18.58-10.73A1.88,1.88,0,0,0,252.63,249.42Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.77,227.49l-18.58,10.73a1.92,1.92,0,0,0-.87,1.5v21.43c0,.56.39.78.87.5l18.58-10.73a1.88,1.88,0,0,0,.86-1.5V228C252.63,227.44,252.25,227.21,251.77,227.49Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.61,227.83c-.06-.43-.42-.59-.85-.34l-18.57,10.73a1.9,1.9,0,0,0-.62.64l-2-1.13a1.64,1.64,0,0,1,.61-.64l18.57-10.74a2,2,0,0,1,1.74,0l.23.14A1.94,1.94,0,0,1,252.61,227.83Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,261.74a1.89,1.89,0,0,1-1.53-.09l-.24-.13a1.92,1.92,0,0,1-.87-1.5V238.59a1.75,1.75,0,0,1,.26-.86l2,1.13a1.85,1.85,0,0,0-.25.86v21.43C232.32,261.63,232.6,261.86,233,261.74Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.34,236.33c1.75-1,3.17-.2,3.17,1.82a7,7,0,0,1-3.17,5.49c-1.75,1-3.17.19-3.17-1.83A7,7,0,0,1,242.34,236.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.58,247.12c0-3.31-2.33-4.79-5.2-3.13l-1.8,1a11.5,11.5,0,0,0-5.2,9v.89s1.23.81,6.1-2.07,6.1-5,6.1-5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.07,233V211.59a1.92,1.92,0,0,0-.87-1.5L280,210a1.91,1.91,0,0,0-1.74,0l-18.58,10.73a1.91,1.91,0,0,0-.86,1.5v21.43a1.91,1.91,0,0,0,.87,1.5l.23.14a2,2,0,0,0,1.73,0l18.58-10.73A1.92,1.92,0,0,0,281.07,233Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.2,211.09l-18.58,10.73a1.94,1.94,0,0,0-.86,1.5v21.44c0,.55.39.77.86.5l18.58-10.73a1.92,1.92,0,0,0,.87-1.5V211.59C281.07,211,280.68,210.82,280.2,211.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.05,211.43c-.06-.43-.42-.59-.85-.34l-18.57,10.73a1.9,1.9,0,0,0-.62.64l-2-1.13a1.64,1.64,0,0,1,.61-.64L278.23,210a2,2,0,0,1,1.74,0l.23.14A1.94,1.94,0,0,1,281.05,211.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.43,245.34a1.89,1.89,0,0,1-1.53-.09l-.24-.13a1.92,1.92,0,0,1-.87-1.5V222.19a1.75,1.75,0,0,1,.26-.86l2,1.13a1.85,1.85,0,0,0-.25.86v21.43C260.76,245.23,261,245.46,261.43,245.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.55,219l-9.28,5.36a6.44,6.44,0,0,0-2.91,5v6.23c0,1.85,1.31,2.61,2.91,1.68l9.28-5.36a6.43,6.43,0,0,0,2.92-5V220.7C278.47,218.85,277.16,218.09,275.55,219Zm-2,7.95-5,5.76c-.26.31-.47.23-.47-.18v-5.4a.73.73,0,0,1,.73-.74h4.48C273.73,226.41,273.84,226.66,273.58,227Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.07,200.21V178.77a1.92,1.92,0,0,0-.87-1.5l-.23-.13a1.91,1.91,0,0,0-1.74,0l-18.58,10.73a1.92,1.92,0,0,0-.86,1.5V210.8a1.91,1.91,0,0,0,.87,1.5l.23.14a2,2,0,0,0,1.73,0l18.58-10.73A1.92,1.92,0,0,0,281.07,200.21Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.2,178.27,261.62,189a1.94,1.94,0,0,0-.86,1.5v21.44c0,.55.39.77.86.5l18.58-10.73a1.92,1.92,0,0,0,.87-1.5V178.77C281.07,178.22,280.68,178,280.2,178.27Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.05,178.61c-.06-.43-.42-.59-.85-.34L261.63,189a1.9,1.9,0,0,0-.62.64l-2-1.13a1.64,1.64,0,0,1,.61-.64l18.57-10.74a2,2,0,0,1,1.74,0l.23.14A1.94,1.94,0,0,1,281.05,178.61Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.43,212.53a1.89,1.89,0,0,1-1.53-.09l-.24-.13a1.92,1.92,0,0,1-.87-1.5V189.37a1.75,1.75,0,0,1,.26-.86l2,1.13a1.85,1.85,0,0,0-.25.86v21.44C260.76,212.42,261,212.65,261.43,212.53Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.47,188.17l1.36,2.91a.33.33,0,0,0,.45.18l3.06-1.18c.49-.18.68.5.33,1.16l-2.21,4.16a1.34,1.34,0,0,0-.17.8l.52,3.77c.08.59-.43,1.38-.86,1.33l-2.74-.34a.68.68,0,0,0-.55.32l-2.74,3.5c-.44.56-.95.36-.86-.34l.52-4.37a.65.65,0,0,0-.17-.6l-2.22-1.6c-.35-.25-.15-1.16.33-1.54l3.06-2.36a1.41,1.41,0,0,0,.45-.69l1.37-4.49C270.62,188.07,271.25,187.71,271.47,188.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.8,350.76a496.68,496.68,0,0,1,4.46-65.52c3.1-21.67,2.5-40.21,1.55-45.45s-4.89-17.89-9.3-22.51c-4.1-4.3-12.16-11.2-19.13-19.38s-13.59-17.43-17.31-22.44-13,3.06-12.51,19c.37,13.06,8.6,25.06,12.74,29.37s9.66,13.14,10,16.73c.28,3-1.83,8.06-6.07,13.39-6.62,8.31-32.63,34.86-12.16,70.05v32.28Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.74,185.23s7.94,10.77,10.47,12.16,3.26-1.78,3.26-1.78h0c-3.65-5.12-10.45-14.44-15.39-20.14A18.9,18.9,0,0,1,285.74,185.23Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.74,185.23s7.94,10.77,10.47,12.16,3.26-1.78,3.26-1.78h0c-3.65-5.12-10.45-14.44-15.39-20.14A18.9,18.9,0,0,1,285.74,185.23Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.47,195.61h0a16.32,16.32,0,0,0-1.18-1.65,3.76,3.76,0,0,1-1.47,3.69h0C298.9,198.25,299.47,195.61,299.47,195.61Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.53,135.8c-6.8-7-16.45-11.92-23.09-6.82s-6.66,17.63-2.48,23.85c6.42,9.53,25.57,25.5,25.57,25.5Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.53,135.8c-.76-.79-1.57-1.55-2.39-2.27h0v29c0,4-14-7.2-19.53-14A22.17,22.17,0,0,1,152.28,135c-2.11,5.86-1.28,13.42,1.68,17.82,6.42,9.53,25.57,25.5,25.57,25.5Z",
    style: {
      fill: "#9a4a4d",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.32,283.32c3.37,5.77,18.21,16.39,18.21,16.39V266.59Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.32,201.48c3.55,6.08,19.21,17.29,19.21,17.29V183.83Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.57,233c4.85,8.58,20,18.59,20,18.59v-32.7Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.6,171.12c8.64-.79,13.17,3,15.1,10.75.73,2.93.81,7.57,0,13.33s-6.26,12.66-13.28,11.62l-.34,0c-11.35-1.84-12.64-7.94-12.64-17.78S159.91,171.82,167.6,171.12Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.8,173.4c.62.55,4.28,4.13,4.32,14.06,0,10.86-5.41,13.11-11.43,14.08s-14.12-2.78-14.12-8.21h0c.52,7.3,2.93,11.88,12.51,13.44l.34,0c7,1,12.47-5.86,13.28-11.62s.73-10.4,0-13.33C181.75,178.07,180.17,175.23,177.8,173.4Z",
    style: {
      fill: "#9a4a4d",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.79,205.73c7.89-.72,12,2.74,13.8,9.81.67,2.68.74,6.92,0,12.18s-5.72,11.56-12.13,10.62l-.32-.05c-10.36-1.68-11.54-7.25-11.54-16.24S160.77,206.37,167.79,205.73Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.79,209.47c1.11,1.65,1.92,5.71,1.26,11.86-.85,8.06-2.58,12-9.63,12.48-7.3.53-11.79-2.85-12.56-6.41.69,5.86,3.16,9.57,11.28,10.89l.32.05c6.41.94,11.39-5.36,12.13-10.62s.67-9.5,0-12.18A15.6,15.6,0,0,0,178.79,209.47Z",
    style: {
      fill: "#9a4a4d",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.22,254.54c8.18-.75,14.31,3.15,14.31,10.19v12.64a11.07,11.07,0,0,1-12.59,11l-.32-.05c-10.76-1.75-10.63-11.58-10.76-16.74S160.93,255.21,168.22,254.54Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.55,256.79c3.57,3.75,2.18,11.37,1.9,18.88-.19,5.21-2.9,9.53-10,9.53s-10.32-4.35-11.28-8.61h0c.59,4.92,2.65,10.48,10.49,11.76l.32.05a11.07,11.07,0,0,0,12.59-11V264.73A9.34,9.34,0,0,0,178.55,256.79Z",
    style: {
      fill: "#9a4a4d",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.22,147.08l7.94-1.78h0l-3.39-2-3.15-1.82a.38.38,0,0,0-.22-.06l-2.78-.16c-.29,0-.5-.22-.47-.45a15.1,15.1,0,0,0,0-2.69,1.3,1.3,0,0,1,.31-.82l4.45-.36c.19-.24,3.83-3.75,3.83-3.75h0l-6.55-3.79a.28.28,0,0,0-.13,0l-5.26-3a.53.53,0,0,0-.32-.06l-3.25.32a.9.9,0,0,0-.71.49l-1.76,4.72a1.49,1.49,0,0,1-.71.69c-.34.16-.69.35-1,.54l-3.41-2c-.14-.09-.35,0-.53.16L107.49,135a.94.94,0,0,0-.28.78l1,3.36a1.13,1.13,0,0,1-.18.81,26.21,26.21,0,0,0-1.64,2.85,1.28,1.28,0,0,1-.77.58l-3,.73a1,1,0,0,0-.69.58l-1.54,5.16a.33.33,0,0,0,.12.38c.06.06,3.45,2,3.45,2,0,.48,0,.94.06,1.39a1.34,1.34,0,0,1-.3.82l-3.11,3.76a.87.87,0,0,0-.19.78l1.48,3.27a.22.22,0,0,0,.09.1l6.56,3.79h0s0,0,0,0l.09.06h0l5.27,3.05h0c.09-.24,2.76-11.32,2.88-11.15l1.66,2.54s0,0,0,.06l3.17,1.84,3.42,2h0l-2.47-7.72C124.79,157.52,129.77,148.13,128.22,147.08ZM109,152.24l12-12.72a6.18,6.18,0,0,1,.5,2.65,6.36,6.36,0,0,1,.82-.42c0,.28,0,.57,0,.88a14.39,14.39,0,0,1-6.53,11.3,8.13,8.13,0,0,1-.77.4c0-.3,0-.62,0-.94C112.51,154.89,110.07,154.55,109,152.24Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.22,147.08l7.94-1.78h0l-3.39-2-3.15-1.82a.38.38,0,0,0-.22-.06l-2.78-.16c-.29,0-.5-.22-.47-.45a15.1,15.1,0,0,0,0-2.69,1.3,1.3,0,0,1,.31-.82l4.45-.36c.19-.24,3.83-3.75,3.83-3.75h0l-6.55-3.79a.28.28,0,0,0-.13,0l-5.26-3a.53.53,0,0,0-.32-.06l-3.25.32a.9.9,0,0,0-.71.49l-1.76,4.72a1.49,1.49,0,0,1-.71.69c-.34.16-.69.35-1,.54l-3.41-2c-.14-.09-.35,0-.53.16L107.49,135a.94.94,0,0,0-.28.78l1,3.36a1.13,1.13,0,0,1-.18.81,26.21,26.21,0,0,0-1.64,2.85,1.28,1.28,0,0,1-.77.58l-3,.73a1,1,0,0,0-.69.58l-1.54,5.16a.33.33,0,0,0,.12.38c.06.06,3.45,2,3.45,2,0,.48,0,.94.06,1.39a1.34,1.34,0,0,1-.3.82l-3.11,3.76a.87.87,0,0,0-.19.78l1.48,3.27a.22.22,0,0,0,.09.1l6.56,3.79h0s0,0,0,0l.09.06h0l5.27,3.05h0c.09-.24,2.76-11.32,2.88-11.15l1.66,2.54s0,0,0,.06l3.17,1.84,3.42,2h0l-2.47-7.72C124.79,157.52,129.77,148.13,128.22,147.08ZM109,152.24l12-12.72a6.18,6.18,0,0,1,.5,2.65,6.36,6.36,0,0,1,.82-.42c0,.28,0,.57,0,.88a14.39,14.39,0,0,1-6.53,11.3,8.13,8.13,0,0,1-.77.4c0-.3,0-.62,0-.94C112.51,154.89,110.07,154.55,109,152.24Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M130.14,145.29l-1.9-3.91-1.64-.09c-.29,0-.5-.22-.47-.45q.06-.74.06-1.44l-4.59.62-.25.3a7.27,7.27,0,0,1,.22,1.85,6.36,6.36,0,0,1,.82-.42c0,.28,0,.57,0,.88a14.39,14.39,0,0,1-6.53,11.3,8.13,8.13,0,0,1-.77.4c0-.3,0-.62,0-.94a6.6,6.6,0,0,1-2.34.87l-.06.17,3.35,6.18h0a19.5,19.5,0,0,1,.73-2.55l1.66,2.54s0,0,0,.06l3.17,1.84,3.42,2h0l-2.47-7.72c2.18.75,7.16-8.64,5.61-9.69l1.54-.34Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.68,160.25s-2.62,3.1-4.6,5.65c.23.13.37.22.41.23h0s0,0,0,0l.09.06h0l5.27,3.05h0c0-.14,1-4.07,1.8-7.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.86,154.09a1.9,1.9,0,0,1-.2.34l-3.11,3.76a.87.87,0,0,0-.19.78l1.48,3.27a.22.22,0,0,0,.09.1l1.91,1.11,3.35,1.17,4.36-6.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,152.24l.57-.6c-2.71-.65-6.44-1.52-6.44-1.52l-.35,1.47,1.1.63c0,.48,0,.94.06,1.39a1.15,1.15,0,0,1-.1.48l7.69,4.45a40.41,40.41,0,0,0,2.09-4l-.24-.38A3.42,3.42,0,0,1,109,152.24Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.51,147.5,106,143.17a1.42,1.42,0,0,1-.41.2l-3,.73a1,1,0,0,0-.69.58l-1.12,3.77,7.15,3,4.24-2.52Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.46,143.78l2-3.76-1.36-4.9-7.59-1.22-1,1.09a.94.94,0,0,0-.28.78l1,3.36a.88.88,0,0,1,0,.45Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.38,132.26,124.6,137l2.25-8.29-4.08-2.37a.53.53,0,0,0-.32-.06l-3.25.32a.9.9,0,0,0-.71.49l-1.76,4.72A1.18,1.18,0,0,1,116.38,132.26Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.49,166.14l-.31-3-7.83-4.51a.61.61,0,0,0,0,.38l1.48,3.27a.22.22,0,0,0,.09.1h0Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.48,148.79l-7.5-4.31a.56.56,0,0,0-.11.2l-1.54,5.17a.34.34,0,0,0,.12.37l0,0,3.38,2,0,0h0l3.15,1.82Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.23,135.44l6.57,3.77,4.33-4.35-6.55-3.79h0c-.14-.09-.35,0-.53.16L107.49,135A1.2,1.2,0,0,0,107.23,135.44Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.77,126.34a.53.53,0,0,0-.32-.06l-3.25.32a.92.92,0,0,0-.54.26l8.53,4.93,2.19-1.26-.07-.4S122.87,126.41,122.77,126.34Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.49,166.14l-.31-3-7.83-4.51a.61.61,0,0,0,0,.38l1.48,3.27a.22.22,0,0,0,.09.1h0Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.48,148.79l-7.5-4.31a.56.56,0,0,0-.11.2l-1.54,5.17a.34.34,0,0,0,.12.37l0,0,3.38,2,0,0h0l3.15,1.82Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.23,135.44l6.57,3.77,4.33-4.35-6.55-3.79h0c-.14-.09-.35,0-.53.16L107.49,135A1.2,1.2,0,0,0,107.23,135.44Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.77,126.34a.53.53,0,0,0-.32-.06l-3.25.32a.92.92,0,0,0-.54.26l8.53,4.93,2.19-1.26-.07-.4S122.87,126.41,122.77,126.34Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.16,145.3h0a.83.83,0,0,0-.2,0l-2.79-.15a.45.45,0,0,1-.46-.46c0-.44.06-.87.06-1.3s0-.93-.06-1.38a1.34,1.34,0,0,1,.3-.82l3.11-3.77a.81.81,0,0,0,.19-.77l-1.48-3.27a.18.18,0,0,0-.09-.1h0a.45.45,0,0,0-.48.15l-3.32,3a.6.6,0,0,1-.73.12,5.19,5.19,0,0,0-1.42-.83.54.54,0,0,1-.33-.58l1-4.64a.27.27,0,0,0-.14-.33.49.49,0,0,0-.31-.06l-3.24.33a.9.9,0,0,0-.71.49l-1.76,4.72a1.49,1.49,0,0,1-.71.69,13.83,13.83,0,0,0-2,1.16c-.28.19-.58.2-.7,0l-1.66-2.54c-.12-.18-.38-.14-.6.08l-3.56,3.77a.94.94,0,0,0-.28.78l1,3.36a1.14,1.14,0,0,1-.18.81,28,28,0,0,0-1.64,2.85,1.35,1.35,0,0,1-.77.58l-3,.73a1.06,1.06,0,0,0-.7.57l-1.53,5.17a.37.37,0,0,0,.38.47l2.79.16a.46.46,0,0,1,.47.45,14.13,14.13,0,0,0,0,2.68,1.35,1.35,0,0,1-.3.83L107.11,162a.86.86,0,0,0-.19.78L108.4,166a.18.18,0,0,0,.09.1h0a.2.2,0,0,0,.11,0h0A.59.59,0,0,0,109,166l3.32-3a.59.59,0,0,1,.72-.12,5.23,5.23,0,0,0,1.42.83.53.53,0,0,1,.34.58l-1,4.65a.29.29,0,0,0,.14.32h0a.46.46,0,0,0,.3.06l3.25-.32a.91.91,0,0,0,.71-.5l1.76-4.72a1.58,1.58,0,0,1,.71-.69c.34-.16.69-.34,1-.54s.66-.4,1-.62.58-.2.7,0l1.66,2.54.08.08c.14.08.34,0,.52-.16l3.57-3.77a.94.94,0,0,0,.27-.78l-1-3.36a1.09,1.09,0,0,1,.18-.81,26.21,26.21,0,0,0,1.64-2.85,1.27,1.27,0,0,1,.77-.57l3.05-.74a1,1,0,0,0,.69-.57l1.54-5.17A.35.35,0,0,0,136.16,145.3Zm-16.28,12.63-.18,0-.13,0-.29,0-.34,0h-.3a3.26,3.26,0,0,1-3.06-2.05,5.73,5.73,0,0,1-.45-1.71c0-.3,0-.62,0-.94a14.54,14.54,0,0,1,4-9.23,11.08,11.08,0,0,1,2.46-2,6.36,6.36,0,0,1,.82-.42,5.16,5.16,0,0,1,2.3-.49H125l.13,0a3.26,3.26,0,0,1,2.55,2c1.38,3-.2,8.36-3.53,11.87A9.29,9.29,0,0,1,119.88,157.93Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.29,190.86h0a.69.69,0,0,0-.5,0l-5.58,2.52a.67.67,0,0,1-.93-.43c-.22-.71-4-1.52-4.35-2.12l2.15-5.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.08,185.56h0a.56.56,0,0,0-.49,0L119.48,176a.85.85,0,0,0-.33-1.09l-4-2.33a.84.84,0,0,0-1.11.26l-4.63,7a1.54,1.54,0,0,1-1.21.6,11.13,11.13,0,0,0-1.62.08v-5.1l-3.1-1.78h0a.48.48,0,0,0-.5,0l-6.27,3.62a1.72,1.72,0,0,0-.75,1.17l-.62,7a2.32,2.32,0,0,1-.66,1.3,38.23,38.23,0,0,0-3.48,3.69,1.2,1.2,0,0,1-1.23.35l-4-1.41a1,1,0,0,0-1.13.42l-4.61,8a1,1,0,0,0,.21,1.19l3.22,2.78a1.2,1.2,0,0,1,.32,1.24,36.86,36.86,0,0,0-1.45,4.86,2.33,2.33,0,0,1-.81,1.21l-5.72,4a1.7,1.7,0,0,0-.64,1.23v7.24a.55.55,0,0,0,.22.47h0l7.26,4.18-2.65,5.34a.85.85,0,0,0,.33,1.09l9.86,5.71a.84.84,0,0,0,1.11-.26l4.48-4.58a.57.57,0,0,0,.24.43l9.19,5.3.25-7.19s-1.94-2.51-1.91-2.94l10-10.9a1,1,0,0,0,1.13-.42l4.6-8a1,1,0,0,0-.2-1.19l4.44-14.12a1.7,1.7,0,0,0,.64-1.23ZM99.8,216c-2.69,1.55-4.91,1.88-6.52,1.13-1.9-.88,13.48-27.25,15.1-25.81,1.3,1.17,2,3.33,2,6.34C110.39,204.41,105.65,212.62,99.8,216Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.61,179.56l-1.25,2.52-4,4.62L115.64,184,109,180.15a1.16,1.16,0,0,0,.34-.32l4.63-7a.85.85,0,0,1,1.1-.26l4.05,2.33,6.13,3.54A.85.85,0,0,1,125.61,179.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.09,208.6a2,2,0,0,1-.43.44l-5.72,4a1.61,1.61,0,0,0-.39.46l9.62,5.57,7.6-4.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.53,189.32a1,1,0,0,0-.75.46l-4.61,8a1,1,0,0,0-.1.62l10.09,5.83,6.3-8.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.65,178.94v2.3l-5.58,3.22-11-6.39a1.68,1.68,0,0,1,.65-.78l6.27-3.62a.61.61,0,0,1,.31-.09.41.41,0,0,1,.19,0l3,1.73.08,0,4.16,2.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.52,198.56v-7.23a.47.47,0,0,0-.71-.46l-5.58,2.51a.66.66,0,0,1-.93-.43,12.69,12.69,0,0,0-1.24-2.76,1.55,1.55,0,0,1-.09-1.36l3.72-7.49a.85.85,0,0,0-.33-1.09l-4-2.33a.84.84,0,0,0-1.11.26l-4.63,7a1.55,1.55,0,0,1-1.21.61,12.33,12.33,0,0,0-3,.3.66.66,0,0,1-.84-.59l-.61-6.08a.46.46,0,0,0-.75-.39l-6.27,3.62a1.7,1.7,0,0,0-.75,1.17l-.62,7a2.37,2.37,0,0,1-.65,1.3,37.19,37.19,0,0,0-3.49,3.69,1.18,1.18,0,0,1-1.23.34l-4-1.4a1,1,0,0,0-1.13.42l-4.61,8a1,1,0,0,0,.21,1.19l3.22,2.78a1.19,1.19,0,0,1,.32,1.24,37.19,37.19,0,0,0-1.45,4.85,2.36,2.36,0,0,1-.8,1.22l-5.73,4a1.7,1.7,0,0,0-.64,1.23v7.24a.47.47,0,0,0,.71.46l5.58-2.52a.67.67,0,0,1,.93.43A12.77,12.77,0,0,0,93,228a1.53,1.53,0,0,1,.09,1.35l-3.72,7.5a.85.85,0,0,0,.33,1.09l4,2.33a.85.85,0,0,0,1.11-.26l4.63-7a1.54,1.54,0,0,1,1.21-.6,12.86,12.86,0,0,0,3-.31.66.66,0,0,1,.83.59l.62,6.09a.46.46,0,0,0,.75.38l6.27-3.61a1.72,1.72,0,0,0,.75-1.17l.62-7a2.41,2.41,0,0,1,.65-1.3,36.92,36.92,0,0,0,3.48-3.68,1.23,1.23,0,0,1,1.24-.35l4,1.4a1,1,0,0,0,1.13-.42l4.6-8a1,1,0,0,0-.2-1.19l-3.22-2.78a1.2,1.2,0,0,1-.32-1.24,37.32,37.32,0,0,0,1.45-4.86,2.4,2.4,0,0,1,.8-1.22l5.73-4A1.72,1.72,0,0,0,133.52,198.56ZM109,221.32c-5.84,3.37-10.58.63-10.58-6.12s4.74-15,10.58-18.33,10.59-.64,10.59,6.11S114.86,217.94,109,221.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.07,149.62h0a.46.46,0,0,0-.44,0l-.68-1.58,1.38-1.6,1.14-2.3a.77.77,0,0,0-.3-1l-5.61-3.23h0l-3.69-2.13h0c-.08-.05-.17,0-.26,0s-.19-.06-.29,0a.8.8,0,0,0-.33.22s-.1,0-.13.09l-.05.08-3,4.46h0L348,140.35h0l-.07,0-1.18-.68-1.58-.91h0a.29.29,0,0,0-.16,0h0a.75.75,0,0,0-.27.08L339,142.07h0a1.31,1.31,0,0,0-.4.41l-.08.13a1,1,0,0,0-.1.17l0,0a1.13,1.13,0,0,0-.13.33l-.57,6.38a2.19,2.19,0,0,1-.6,1.19,35.2,35.2,0,0,0-3.18,3.37,1.09,1.09,0,0,1-1.13.32l-3.68-1.28a.81.81,0,0,0-.27,0l-.07,0a.44.44,0,0,0-.15,0l-.14,0a.93.93,0,0,0-.4.33l-4.21,7.3a.84.84,0,0,0-.1.56h0a1,1,0,0,0,.28.53l3,2.54a1.09,1.09,0,0,1,.29,1.13A35.77,35.77,0,0,0,326,170a2.13,2.13,0,0,1-.73,1.11L320,174.81a1.45,1.45,0,0,0-.36.41h0a1.49,1.49,0,0,0-.23.7v6.62a.48.48,0,0,0,.2.43h0l6.64,3.83-2.42,4.88a.77.77,0,0,0,.3,1l9,5.22a.77.77,0,0,0,1-.23l4.1-4.2a.5.5,0,0,0,.22.4l8.4,4.85.23-6.58a14.4,14.4,0,0,1-1.75-2.69l9.16-10a.91.91,0,0,0,1-.38l4.21-7.3a.88.88,0,0,0-.18-1.08l4.05-12.92a1.55,1.55,0,0,0,.59-1.13l0-1.2c.9.32,1.75.65,1.85,1a.6.6,0,0,0,.85.39l5.1-2.29a.62.62,0,0,1,.45-.05Zm-22.21,27.86c-2.46,1.42-4.49,1.73-6,1-1.73-.81,12.34-24.93,13.82-23.61,1.19,1.06,1.84,3,1.84,5.8C351.55,166.89,347.21,174.39,341.86,177.48Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.07,149.62h0a.46.46,0,0,0-.44,0l-.68-1.58,1.38-1.6,1.14-2.3a.77.77,0,0,0-.3-1l-5.61-3.23h0l-3.69-2.13h0c-.08-.05-.17,0-.26,0s-.19-.06-.29,0a.8.8,0,0,0-.33.22s-.1,0-.13.09l-.05.08-3,4.46h0L348,140.35h0l-.07,0-1.18-.68-1.58-.91h0a.29.29,0,0,0-.16,0h0a.75.75,0,0,0-.27.08L339,142.07h0a1.31,1.31,0,0,0-.4.41l-.08.13a1,1,0,0,0-.1.17l0,0a1.13,1.13,0,0,0-.13.33l-.57,6.38a2.19,2.19,0,0,1-.6,1.19,35.2,35.2,0,0,0-3.18,3.37,1.09,1.09,0,0,1-1.13.32l-3.68-1.28a.81.81,0,0,0-.27,0l-.07,0a.44.44,0,0,0-.15,0l-.14,0a.93.93,0,0,0-.4.33l-4.21,7.3a.84.84,0,0,0-.1.56h0a1,1,0,0,0,.28.53l3,2.54a1.09,1.09,0,0,1,.29,1.13A35.77,35.77,0,0,0,326,170a2.13,2.13,0,0,1-.73,1.11L320,174.81a1.45,1.45,0,0,0-.36.41h0a1.49,1.49,0,0,0-.23.7v6.62a.48.48,0,0,0,.2.43h0l6.64,3.83-2.42,4.88a.77.77,0,0,0,.3,1l9,5.22a.77.77,0,0,0,1-.23l4.1-4.2a.5.5,0,0,0,.22.4l8.4,4.85.23-6.58a14.4,14.4,0,0,1-1.75-2.69l9.16-10a.91.91,0,0,0,1-.38l4.21-7.3a.88.88,0,0,0-.18-1.08l4.05-12.92a1.55,1.55,0,0,0,.59-1.13l0-1.2c.9.32,1.75.65,1.85,1a.6.6,0,0,0,.85.39l5.1-2.29a.62.62,0,0,1,.45-.05Zm-22.21,27.86c-2.46,1.42-4.49,1.73-6,1-1.73-.81,12.34-24.93,13.82-23.61,1.19,1.06,1.84,3,1.84,5.8C351.55,166.89,347.21,174.39,341.86,177.48Z",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.14,156c.13-.15.25-.29.37-.41V144.94l-7.73-3.9-1.78,1h0a1.31,1.31,0,0,0-.4.41l-.08.13a1,1,0,0,0-.1.17l0,0a1.13,1.13,0,0,0-.13.33l-.57,6.38a1.54,1.54,0,0,1-.14.43Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.4,159.54l-8.92-5.16a1,1,0,0,1-.65,0l-3.68-1.28a.81.81,0,0,0-.27,0l-.07,0a.44.44,0,0,0-.15,0l-.14,0a.93.93,0,0,0-.4.33l-1.73,3,.43,2.09L338.41,162Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.9,170.68l-2-6.49-10.34-4.51-.65,1.12a.84.84,0,0,0-.1.56h0a1,1,0,0,0,.28.53l3,2.54a1,1,0,0,1,.3.73Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.36,190.33l-6.64-3.83-2.65,1.34-1.78-1-2.42,4.88a.77.77,0,0,0,.3,1l8.05,4.66Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.92,159.1l-11.82-2.56-.23.18a10.56,10.56,0,0,1,.68,4c0,6.18-4.34,13.68-9.69,16.77a8.53,8.53,0,0,1-4.33,1.35l1.74,12.34-.55,2.82,8.21,4.74.23-6.58a14.4,14.4,0,0,1-1.75-2.69l9.16-10a.91.91,0,0,0,1-.38l4.21-7.3a.88.88,0,0,0-.18-1.08l3.29-10.48C362.92,159.54,362.92,159.1,362.92,159.1Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.5,154.48h0a.64.64,0,0,0-.46.05l-5.1,2.29a.6.6,0,0,1-.85-.39c-.2-.64-3.7-1.38-4-1.93l2-4.88Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.47,144.15l-1.14,2.3-3.66,4.23-4.32-2.5-6-3.49a1,1,0,0,0,.3-.3l4.24-6.37a.78.78,0,0,1,1-.24l3.7,2.13,5.61,3.24A.77.77,0,0,1,365.47,144.15Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.66,170.71a1.92,1.92,0,0,1-.39.41L320,174.81a1.45,1.45,0,0,0-.36.41l8.81,5.1,6.95-4Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.81,153.08a.91.91,0,0,0-.69.42l-4.21,7.3a.84.84,0,0,0-.1.56L333,166.7l5.77-7.8Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.81,153.08a.91.91,0,0,0-.69.42l-4.21,7.3a.84.84,0,0,0-.1.56L333,166.7l5.77-7.8Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.62,143.59v2.09l-5.11,2.95-10.1-5.84a1.47,1.47,0,0,1,.59-.72l5.73-3.3a.57.57,0,0,1,.28-.09.34.34,0,0,1,.18,0l2.76,1.59.07,0,3.81,2.21Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.62,143.59v2.09l-5.11,2.95-10.1-5.84a1.47,1.47,0,0,1,.59-.72l5.73-3.3a.57.57,0,0,1,.28-.09.34.34,0,0,1,.18,0l2.76,1.59.07,0,3.81,2.21Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.71,161.53v-6.62a.43.43,0,0,0-.66-.42l-5.1,2.3a.61.61,0,0,1-.85-.39,11.5,11.5,0,0,0-1.14-2.53,1.42,1.42,0,0,1-.07-1.24l3.4-6.85a.78.78,0,0,0-.3-1l-3.7-2.13a.76.76,0,0,0-1,.23L359,149.26a1.4,1.4,0,0,1-1.11.55,11.65,11.65,0,0,0-2.76.28.61.61,0,0,1-.76-.54l-.56-5.57a.43.43,0,0,0-.69-.35l-5.74,3.31a1.53,1.53,0,0,0-.68,1.07l-.57,6.37a2.18,2.18,0,0,1-.6,1.2,31.91,31.91,0,0,0-3.18,3.37,1.09,1.09,0,0,1-1.13.31L337.58,158a.89.89,0,0,0-1,.38l-4.22,7.3a.91.91,0,0,0,.19,1.09l3,2.54a1.12,1.12,0,0,1,.29,1.14,33.56,33.56,0,0,0-1.33,4.44,2.11,2.11,0,0,1-.73,1.11l-5.24,3.69a1.55,1.55,0,0,0-.58,1.13v6.61a.43.43,0,0,0,.65.43l5.1-2.3a.6.6,0,0,1,.85.39,11.5,11.5,0,0,0,1.14,2.53,1.42,1.42,0,0,1,.07,1.24l-3.4,6.85a.78.78,0,0,0,.3,1l3.7,2.13a.76.76,0,0,0,1-.24l4.24-6.37a1.4,1.4,0,0,1,1.11-.55,11.65,11.65,0,0,0,2.76-.28.6.6,0,0,1,.76.54l.56,5.57a.43.43,0,0,0,.69.35l5.74-3.31a1.55,1.55,0,0,0,.68-1.07l.57-6.38a2.19,2.19,0,0,1,.6-1.19,32.91,32.91,0,0,0,3.18-3.37,1.12,1.12,0,0,1,1.13-.32l3.68,1.29a.88.88,0,0,0,1-.39l4.22-7.29a.91.91,0,0,0-.19-1.09L365.11,173a1.1,1.1,0,0,1-.29-1.13,34,34,0,0,0,1.33-4.44,2.11,2.11,0,0,1,.73-1.11l5.24-3.69A1.56,1.56,0,0,0,372.71,161.53Zm-22.42,20.82c-5.35,3.08-9.68.58-9.68-5.6s4.33-13.68,9.68-16.77,9.68-.58,9.68,5.59S355.64,179.26,350.29,182.35Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.71,161.53v-6.62a.43.43,0,0,0-.66-.42l-5.1,2.3a.61.61,0,0,1-.85-.39,11.5,11.5,0,0,0-1.14-2.53,1.42,1.42,0,0,1-.07-1.24l3.4-6.85a.78.78,0,0,0-.3-1l-3.7-2.13a.76.76,0,0,0-1,.23L359,149.26a1.4,1.4,0,0,1-1.11.55,11.65,11.65,0,0,0-2.76.28.61.61,0,0,1-.76-.54l-.56-5.57a.43.43,0,0,0-.69-.35l-5.74,3.31a1.53,1.53,0,0,0-.68,1.07l-.57,6.37a2.18,2.18,0,0,1-.6,1.2,31.91,31.91,0,0,0-3.18,3.37,1.09,1.09,0,0,1-1.13.31L337.58,158a.89.89,0,0,0-1,.38l-4.22,7.3a.91.91,0,0,0,.19,1.09l3,2.54a1.12,1.12,0,0,1,.29,1.14,33.56,33.56,0,0,0-1.33,4.44,2.11,2.11,0,0,1-.73,1.11l-5.24,3.69a1.55,1.55,0,0,0-.58,1.13v6.61a.43.43,0,0,0,.65.43l5.1-2.3a.6.6,0,0,1,.85.39,11.5,11.5,0,0,0,1.14,2.53,1.42,1.42,0,0,1,.07,1.24l-3.4,6.85a.78.78,0,0,0,.3,1l3.7,2.13a.76.76,0,0,0,1-.24l4.24-6.37a1.4,1.4,0,0,1,1.11-.55,11.65,11.65,0,0,0,2.76-.28.6.6,0,0,1,.76.54l.56,5.57a.43.43,0,0,0,.69.35l5.74-3.31a1.55,1.55,0,0,0,.68-1.07l.57-6.38a2.19,2.19,0,0,1,.6-1.19,32.91,32.91,0,0,0,3.18-3.37,1.12,1.12,0,0,1,1.13-.32l3.68,1.29a.88.88,0,0,0,1-.39l4.22-7.29a.91.91,0,0,0-.19-1.09L365.11,173a1.1,1.1,0,0,1-.29-1.13,34,34,0,0,0,1.33-4.44,2.11,2.11,0,0,1,.73-1.11l5.24-3.69A1.56,1.56,0,0,0,372.71,161.53Zm-22.42,20.82c-5.35,3.08-9.68.58-9.68-5.6s4.33-13.68,9.68-16.77,9.68-.58,9.68,5.59S355.64,179.26,350.29,182.35Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.05,202.32l7.65-1.72h0l-3.27-1.89-3-1.76a.38.38,0,0,0-.22-.06l-2.68-.15a.44.44,0,0,1-.46-.44,15,15,0,0,0,0-2.59,1.23,1.23,0,0,1,.29-.79l4.3-.35c.18-.23,3.7-3.62,3.7-3.62h0L382,185.27a.22.22,0,0,0-.12,0l-5.08-2.95a.57.57,0,0,0-.31-.06l-3.13.31a.9.9,0,0,0-.69.48L371,187.59a1.53,1.53,0,0,1-.69.66c-.33.15-.66.33-1,.52l-3.28-1.9c-.13-.09-.34,0-.51.15L362,190.65a.9.9,0,0,0-.27.76l1,3.24a1.06,1.06,0,0,1-.18.78,27.9,27.9,0,0,0-1.58,2.75,1.27,1.27,0,0,1-.75.55l-2.94.71a1,1,0,0,0-.67.56l-1.48,5a.33.33,0,0,0,.11.36c.07.06,3.34,1.94,3.34,1.94a11.63,11.63,0,0,0,.06,1.33,1.29,1.29,0,0,1-.3.8l-3,3.63a.82.82,0,0,0-.18.75l1.43,3.15a.22.22,0,0,0,.09.1L363,220.7h0l0,0,.1,0h0l5.08,2.94h0c.09-.24,2.67-10.93,2.78-10.76l1.61,2.45.05.06,3.06,1.77,3.3,1.92h0l-2.38-7.45C378.73,212.39,383.54,203.32,382.05,202.32Zm-18.53,5L375.15,195a6.21,6.21,0,0,1,.48,2.55,7.33,7.33,0,0,1,.79-.4c0,.27,0,.55,0,.86a13.91,13.91,0,0,1-6.29,10.9c-.25.14-.51.27-.74.38a5.38,5.38,0,0,1-.05-.91C366.88,209.85,364.53,209.52,363.52,207.29Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M382.05,202.32l7.65-1.72h0l-3.27-1.89-3-1.76a.38.38,0,0,0-.22-.06l-2.68-.15a.44.44,0,0,1-.46-.44,15,15,0,0,0,0-2.59,1.23,1.23,0,0,1,.29-.79l4.3-.35c.18-.23,3.7-3.62,3.7-3.62h0L382,185.27a.22.22,0,0,0-.12,0l-5.08-2.95a.57.57,0,0,0-.31-.06l-3.13.31a.9.9,0,0,0-.69.48L371,187.59a1.53,1.53,0,0,1-.69.66c-.33.15-.66.33-1,.52l-3.28-1.9c-.13-.09-.34,0-.51.15L362,190.65a.9.9,0,0,0-.27.76l1,3.24a1.06,1.06,0,0,1-.18.78,27.9,27.9,0,0,0-1.58,2.75,1.27,1.27,0,0,1-.75.55l-2.94.71a1,1,0,0,0-.67.56l-1.48,5a.33.33,0,0,0,.11.36c.07.06,3.34,1.94,3.34,1.94a11.63,11.63,0,0,0,.06,1.33,1.29,1.29,0,0,1-.3.8l-3,3.63a.82.82,0,0,0-.18.75l1.43,3.15a.22.22,0,0,0,.09.1L363,220.7h0l0,0,.1,0h0l5.08,2.94h0c.09-.24,2.67-10.93,2.78-10.76l1.61,2.45.05.06,3.06,1.77,3.3,1.92h0l-2.38-7.45C378.73,212.39,383.54,203.32,382.05,202.32Zm-18.53,5L375.15,195a6.21,6.21,0,0,1,.48,2.55,7.33,7.33,0,0,1,.79-.4c0,.27,0,.55,0,.86a13.91,13.91,0,0,1-6.29,10.9c-.25.14-.51.27-.74.38a5.38,5.38,0,0,1-.05-.91C366.88,209.85,364.53,209.52,363.52,207.29Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M383.9,200.59l-1.84-3.77-1.58-.09a.44.44,0,0,1-.46-.44c0-.47.06-.93.06-1.39l-4.42.6-.25.29a7.23,7.23,0,0,1,.22,1.78,7.33,7.33,0,0,1,.79-.4c0,.27,0,.55,0,.86a13.91,13.91,0,0,1-6.29,10.9c-.25.14-.51.27-.74.38a5.38,5.38,0,0,1-.05-.91,6.23,6.23,0,0,1-2.26.84l-.06.16,3.23,6h0a22.61,22.61,0,0,1,.7-2.46l1.61,2.45.05.06,3.06,1.77,3.3,1.92h0l-2.38-7.45c2.1.73,6.91-8.34,5.42-9.34l1.48-.33Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.05,215s-2.53,3-4.44,5.46l.39.22h0l0,0,.1,0h0l5.08,2.94h0c0-.14,1-3.93,1.75-7Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.53,209.08a1.35,1.35,0,0,1-.19.33l-3,3.63a.82.82,0,0,0-.18.75l1.43,3.15a.22.22,0,0,0,.09.1l1.84,1.07,3.24,1.12,4.2-5.86Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.52,207.29l.54-.57-6.21-1.48-.33,1.43,1.06.61a11.63,11.63,0,0,0,.06,1.33,1,1,0,0,1-.11.47l7.43,4.29a35.79,35.79,0,0,0,2-3.91l-.22-.36A3.3,3.3,0,0,1,363.52,207.29Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.85,202.72l-7.23-4.17a1.2,1.2,0,0,1-.4.18l-2.94.71a1,1,0,0,0-.67.56l-1.08,3.63,6.91,2.91,4.09-2.43Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.73,199.13l1.94-3.63-1.31-4.73L363,189.59l-1,1.06a.9.9,0,0,0-.27.76l1,3.24a.87.87,0,0,1,0,.42Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.62,188l7.93,4.58s1.48-5.48,2.17-8l-3.94-2.29a.57.57,0,0,0-.31-.06l-3.13.31a.9.9,0,0,0-.69.48L371,187.59A1.4,1.4,0,0,1,370.62,188Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,220.7l-.31-2.93-7.55-4.35a.66.66,0,0,0,0,.37l1.43,3.15a.22.22,0,0,0,.09.1h0Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,204l-7.24-4.17a.56.56,0,0,0-.11.2l-1.48,5a.34.34,0,0,0,.12.37l.05,0,3.26,1.89h0l3,1.76Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.79,191.08l6.34,3.64,4.18-4.19L366,186.87h0c-.13-.09-.33,0-.5.15L362,190.65A1.1,1.1,0,0,0,361.79,191.08Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.78,182.3a.49.49,0,0,0-.31-.06l-3.13.31a.91.91,0,0,0-.52.25l8.23,4.76,2.11-1.22-.06-.38S376.88,182.37,376.78,182.3Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,220.7l-.31-2.93-7.55-4.35a.66.66,0,0,0,0,.37l1.43,3.15a.22.22,0,0,0,.09.1h0Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,204l-7.24-4.17a.56.56,0,0,0-.11.2l-1.48,5a.34.34,0,0,0,.12.37l.05,0,3.26,1.89h0l3,1.76Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.79,191.08l6.34,3.64,4.18-4.19L366,186.87h0c-.13-.09-.33,0-.5.15L362,190.65A1.1,1.1,0,0,0,361.79,191.08Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.78,182.3a.49.49,0,0,0-.31-.06l-3.13.31a.91.91,0,0,0-.52.25l8.23,4.76,2.11-1.22-.06-.38S376.88,182.37,376.78,182.3Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.7,200.6h0a.38.38,0,0,0-.19-.05l-2.69-.15a.44.44,0,0,1-.45-.44c0-.42.06-.84.06-1.25a9.87,9.87,0,0,0-.06-1.34,1.35,1.35,0,0,1,.3-.79l3-3.63a.85.85,0,0,0,.18-.75L388.41,189a.22.22,0,0,0-.09-.1h0c-.12-.06-.29,0-.46.14l-3.2,2.93a.57.57,0,0,1-.7.12,4.87,4.87,0,0,0-1.37-.8.53.53,0,0,1-.33-.56l1-4.49a.27.27,0,0,0-.13-.31.56.56,0,0,0-.3-.05l-3.13.31a.87.87,0,0,0-.69.48l-1.7,4.55a1.41,1.41,0,0,1-.68.66,13.5,13.5,0,0,0-1.94,1.13c-.26.17-.56.19-.67,0l-1.61-2.45c-.11-.17-.37-.13-.58.08l-3.43,3.64a.89.89,0,0,0-.27.75l1,3.24a1.11,1.11,0,0,1-.18.78,26,26,0,0,0-1.58,2.75,1.24,1.24,0,0,1-.75.56l-2.94.71a1,1,0,0,0-.67.55l-1.48,5c-.07.23.1.43.37.45l2.69.15a.43.43,0,0,1,.45.44,15,15,0,0,0,0,2.59,1.25,1.25,0,0,1-.29.79l-3,3.63a.85.85,0,0,0-.18.75l1.42,3.15a.18.18,0,0,0,.09.1h0l.12,0h0a.55.55,0,0,0,.35-.16l3.2-2.93a.59.59,0,0,1,.7-.12,5.12,5.12,0,0,0,1.37.8.51.51,0,0,1,.32.56l-1,4.49a.28.28,0,0,0,.13.3h0a.48.48,0,0,0,.3,0l3.13-.31a.85.85,0,0,0,.68-.47l1.71-4.56a1.41,1.41,0,0,1,.68-.66c.33-.16.66-.33,1-.53s.62-.38.94-.59.56-.2.67,0l1.61,2.45a.23.23,0,0,0,.07.07c.13.08.33,0,.5-.15l3.44-3.64a.89.89,0,0,0,.27-.75l-1-3.24a1.11,1.11,0,0,1,.18-.78A27.07,27.07,0,0,0,384,207.8a1.28,1.28,0,0,1,.75-.56l2.94-.71a.92.92,0,0,0,.66-.55l1.49-5A.33.33,0,0,0,389.7,200.6ZM374,212.78l-.17.05-.12,0-.28,0-.33,0h-.29a3.14,3.14,0,0,1-2.95-2,5.14,5.14,0,0,1-.43-1.65,5.38,5.38,0,0,1-.05-.91,13.94,13.94,0,0,1,3.88-8.9,10.74,10.74,0,0,1,2.38-1.93,7.33,7.33,0,0,1,.79-.4,5,5,0,0,1,2.22-.47h.25l.12,0a3.13,3.13,0,0,1,2.46,1.94c1.33,2.94-.19,8.07-3.4,11.46A9,9,0,0,1,374,212.78Z",
    style: {
      fill: "#ED5802"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.41,82.45,140.29,51.83c-.87-2-2.64-3.46-3.95-3.21l-29.24,5.6a4.31,4.31,0,0,0-2.95,3.34l-.77,3.9a13.4,13.4,0,0,0,1,6.55L117.5,98.62c.87,2,2.64,3.46,4,3.22l29.24-5.6a4.34,4.34,0,0,0,2.95-3.34l.77-3.9A13.3,13.3,0,0,0,153.41,82.45Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.6,86.54l-29.23,5.61c-1.32.24-3.09-1.2-4-3.22L106.29,58.32c-.87-2-.5-3.86.81-4.1l29.24-5.6c1.31-.25,3.08,1.19,3.95,3.21l13.12,30.62C154.28,84.47,153.92,86.3,152.6,86.54Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.69,96.24l-29.24,5.6a2.74,2.74,0,0,1-2.14-.76l1.91-9.7a2.78,2.78,0,0,0,2.15.77l29.23-5.6c1.25-.24,1.64-1.9.94-3.78a13.38,13.38,0,0,1,.87,6.23l-.77,3.9A4.32,4.32,0,0,1,150.69,96.24Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.31,101.08a4.88,4.88,0,0,1-.94-1l-.19-.26a6.81,6.81,0,0,1-.45-.73c-.08-.16-.16-.32-.23-.48L104.37,68a13.43,13.43,0,0,1-1-6.55l.78-3.9a4.39,4.39,0,0,1,2.64-3.25c-1.06.45-1.3,2.14-.5,4l13.12,30.62a6.58,6.58,0,0,0,1.81,2.44Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.87,60.66A6.11,6.11,0,0,1,135.74,62a4.94,4.94,0,0,0,.73-3.48,6.13,6.13,0,0,1-2.21,1.9,4.71,4.71,0,0,0-3.77-1.17c-2.35.46-3.34,3.35-2.2,6.46a8.64,8.64,0,0,0,.58,1.27c-3.63.46-7.6-1.17-11-4.17a7.2,7.2,0,0,0,.46,3A8,8,0,0,0,122,70.09a4,4,0,0,1-2.19-.32.19.19,0,0,1,0,.07c1,2.73,3.31,4.72,5.45,4.85a3,3,0,0,1-1,.42,3.87,3.87,0,0,1-.84.06c1.37,2.13,3.54,3.45,5.42,3.13a6.23,6.23,0,0,1-4.41,3.45,9.38,9.38,0,0,1-1,.12,11.77,11.77,0,0,0,7.47,1.25c7.86-1.54,9-11,6.27-18.41-.09-.24-.18-.48-.28-.72a9,9,0,0,0,1.07-3.33Zm0,0",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,296.77,108.3,266.35c-.77-2.17-2.6-3.91-4.1-3.89l-29.36.43a4.25,4.25,0,0,0-3.64,2.84l-1.26,3.78a12.44,12.44,0,0,0,.46,6.73l10.68,30.42c.77,2.17,2.6,3.92,4.1,3.89l29.37-.42a4.3,4.3,0,0,0,3.64-2.85l1.25-3.78A12.43,12.43,0,0,0,119,296.77Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.67,300.74l-29.37.43c-1.49,0-3.33-1.72-4.1-3.89L73.52,266.85c-.77-2.17-.18-3.94,1.32-4l29.36-.43c1.5,0,3.33,1.72,4.1,3.89L119,296.77C119.75,298.94,119.16,300.72,117.67,300.74Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.55,310.13l-29.37.43a3.55,3.55,0,0,1-2.32-1.13L86,300a3.52,3.52,0,0,0,2.32,1.13l29.37-.43c1.42,0,2-1.62,1.42-3.63a12.19,12.19,0,0,1,.35,6.39l-1.25,3.79A4.3,4.3,0,0,1,114.55,310.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.86,309.43a5.93,5.93,0,0,1-1-1.14l-.19-.29a7,7,0,0,1-.43-.81c-.07-.17-.14-.34-.2-.52l-10.7-30.43a12.44,12.44,0,0,1-.45-6.73l1.26-3.78a4.3,4.3,0,0,1,3.29-2.81c-1.24.28-1.68,1.93-1,3.94L84.2,297.28A7.28,7.28,0,0,0,86,300Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4,277.87c-2.91,0-4.58,2.42-3.15,6.71s4.53,6,7.44,5.95,4.54-1.77,3.11-6S98.31,277.84,95.4,277.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.52 272.43 85.88 272.4 86.33 273.72 83.96 273.75 83.52 272.43",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.35,274.63l-4.49,0c-.86,0-1.89-1-2.31-2.26s-1.45-2.27-2.3-2.26l-6.83.07c-.85,0-1.2,1-.78,2.29s.07,2.28-.79,2.29l-4.49,0c-.85,0-1.2,1-.78,2.29l5.31,15.5c.42,1.25,1.45,2.26,2.3,2.26l22-.22c.85,0,1.2-1,.78-2.29l-5.31-15.49C107.23,275.63,106.2,274.62,105.35,274.63Zm-5.14,17.24c-3.62,0-7.47-1.95-9.25-7.28s.19-8.59,3.81-8.62,7.54,3.16,9.32,8.49S103.83,291.84,100.21,291.87Zm2.59-12.17c-.46,0-1-.55-1.26-1.24s0-1.24.43-1.25,1,.55,1.26,1.24S103.27,279.7,102.8,279.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.75,151.88,426,162.53a6.39,6.39,0,0,0-3.81,3.82l-8.52,30.74c-.43,1.56-.08,3.42.8,4.14l2.13,1.76c.87.73,2.93.87,4.6.33L454,192.67a6.42,6.42,0,0,0,3.81-3.82l8.52-30.74c.43-1.56.07-3.42-.8-4.14l-2.13-1.76C462.48,151.48,460.42,151.34,458.75,151.88Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,153.73l-8.51,30.74a6.38,6.38,0,0,1-3.81,3.81l-32.77,10.66c-1.67.54-2.67-.29-2.24-1.85l8.52-30.74a6.39,6.39,0,0,1,3.81-3.82l32.77-10.65C460.42,151.34,461.42,152.17,461,153.73Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.28,158.11l-8.52,30.74a5.48,5.48,0,0,1-1.44,2.29l-5.3-4.38a5.47,5.47,0,0,0,1.45-2.29L461,153.73c.4-1.48-.47-2.31-2-1.92,1.61-.46,3.51-.28,4.34.4l2.13,1.75C466.36,154.68,466.71,156.54,466.28,158.11Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.32,191.14a7,7,0,0,1-1,.86l-.25.16a5.38,5.38,0,0,1-.67.35c-.13.05-.27.11-.41.15l-32.77,10.67c-1.67.54-3.73.39-4.61-.33l-2.12-1.77a4.14,4.14,0,0,1-.88-3.77c-.19,1.32.78,2,2.32,1.48l32.77-10.65a6.19,6.19,0,0,0,2.36-1.53Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.68,164c3.09-.94,4.89.68,4,3.62a11.89,11.89,0,0,1-7.19,7c-3.1,1-4.89-.67-4-3.62A11.93,11.93,0,0,1,440.68,164Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.42,181.64c1.45-4.83-1.44-7.68-6.52-6.13l-3.17,1C430.65,178,425.35,183.2,423.9,188l-.39,1.3s1.51,1.55,10.16-1.18,11.42-5.39,11.42-5.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.69,60.36,353.45,53.1a5.34,5.34,0,0,0-4.73,1.84L328.53,77.87a7.7,7.7,0,0,0-2,4.76l.28,3a3.74,3.74,0,0,0,2.71,2.92l27.24,7.26A5.37,5.37,0,0,0,361.48,94l20.18-22.92a7.74,7.74,0,0,0,2-4.76l-.28-3A3.74,3.74,0,0,0,380.69,60.36Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,63.54,360.79,86.47c-1.23,1.39-3.35,2.21-4.73,1.84l-27.24-7.26c-1.39-.37-1.52-1.8-.29-3.18l20.19-22.93a5.34,5.34,0,0,1,4.73-1.84l27.24,7.26C382.08,60.73,382.2,62.16,381,63.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.66,71.07,361.48,94a6,6,0,0,1-2.31,1.58l-.69-7.52a6,6,0,0,0,2.31-1.58L381,63.54c1.16-1.31,1.11-2.66-.09-3.1a3.72,3.72,0,0,1,2.51,2.84l.28,3A7.68,7.68,0,0,1,381.66,71.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.17,95.57a4.49,4.49,0,0,1-1.18.31l-.26,0a2.63,2.63,0,0,1-.63,0,2,2,0,0,1-.35-.07L329.5,88.57a3.77,3.77,0,0,1-2.72-2.92l-.27-3a7.38,7.38,0,0,1,1.74-4.41c-.92,1.27-.71,2.49.57,2.84l27.24,7.26a4,4,0,0,0,2.42-.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.34,76.2l-3.75-1-8.28,9.69-5.53-1.47L346,73.77l-2.65-.69,3.35-4,2.64.69,2.61-3c1.87-2.17,5.84-5.29,10.41-4.1l4.1,1.09-3.91,4.56-3-.78a2.28,2.28,0,0,0-2.28,1l-2.38,2.75,4.24,1.11Zm0,0",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.88,308.81l-7-32.61c-.39-1.82-1.83-3.57-3.21-3.92l-27.11-6.78a3.7,3.7,0,0,0-3.76,1.26l-1.71,2.54a7.9,7.9,0,0,0-.56,5.18l7,32.61c.39,1.82,1.83,3.57,3.21,3.92l27.11,6.78a3.67,3.67,0,0,0,3.76-1.26l1.71-2.54A7.9,7.9,0,0,0,412.88,308.81Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.09,311.48,384,304.69c-1.38-.34-2.82-2.1-3.21-3.92l-7-32.6c-.39-1.82.41-3,1.79-2.67l27.11,6.78c1.38.35,2.82,2.1,3.21,3.92l7,32.61C413.27,310.63,412.47,311.82,411.09,311.48Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.85,317.8,379.74,311a4,4,0,0,1-2-1.41l4.24-6.32a3.84,3.84,0,0,0,2,1.41l27.11,6.79c1.31.32,2.1-.73,1.84-2.39a7.8,7.8,0,0,1-.61,4.9l-1.7,2.55A3.74,3.74,0,0,1,406.85,317.8Z",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.77,309.6a5,5,0,0,1-.71-1.09,2.1,2.1,0,0,1-.13-.26,4.87,4.87,0,0,1-.28-.72c0-.14-.08-.29-.11-.44l-7-32.61a7.9,7.9,0,0,1,.56-5.18l1.71-2.54a3.63,3.63,0,0,1,3.44-1.32c-1.18-.09-1.82,1.05-1.47,2.73l7,32.61a6,6,0,0,0,1.24,2.5Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.7,275.19l4,16.49a7.68,7.68,0,0,0-1.75-.63c-1.92-.41-3,1.33-2.38,3.9s2.65,5,4.57,5.39,3.73-1.2,3.12-3.77l-3.59-14.65,11.17,2.47,2.57,10.3a7.27,7.27,0,0,0-1.75-.64c-1.92-.41-2.35,1.44-1.75,4s2.65,5,4.57,5.39,3-1.34,2.39-3.9h0l-5-20.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.94,183.68l17-27c1.08-1.71,1.33-4.16.54-5.45L48.13,125.77a3.87,3.87,0,0,0-3.8-1.83l-3.21.72c-1.32.29-3.27,1.91-4.35,3.63L20.85,154.91c-1.08,1.71-1.33,4.16-.55,5.46l15.34,25.5a3.87,3.87,0,0,0,3.8,1.83l2.15-.39C42.91,187,44.85,185.39,45.94,183.68Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.56,184.43,27.23,158.92c-.78-1.3-.54-3.74.54-5.45l17-27c1.09-1.71,2.6-2,3.38-.74l15.33,25.51c.79,1.29.54,3.74-.54,5.45l-17,27C44.85,185.39,43.34,185.73,42.56,184.43Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.63,185.88,20.3,160.37a4.25,4.25,0,0,1-.42-2.58l6.93-1.44a4.19,4.19,0,0,0,.42,2.57l15.33,25.51c.74,1.23,2.14,1,3.2-.49a8.62,8.62,0,0,1-4.17,3.37l-2.15.39A3.88,3.88,0,0,1,35.63,185.88Z",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.88,157.79a6.76,6.76,0,0,1,.28-1.38l.11-.3a5.8,5.8,0,0,1,.33-.76,4.41,4.41,0,0,1,.25-.43l15.92-26.64a8.81,8.81,0,0,1,4.35-3.63l3.21-.71a3.78,3.78,0,0,1,3.6,1.54c-.82-1-2.17-.54-3.18,1l-17,27a6.65,6.65,0,0,0-1,2.88Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.84,137.41a.93.93,0,0,0-.92.44L34.1,158.23a.79.79,0,0,0-.13.39l13.5-1.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9,152.94l-8.74-14.09-.38,20.08-14.09,1.29,8.51,14.07a1,1,0,0,0,1.62,0L57.9,154A.94.94,0,0,0,57.9,152.94Z",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileappsAmico);
export default __webpack_public_path__ + "static/media/Mobile apps-amico.1c65c75ba97bb3979f297468c4fa85e1.svg";
export { ForwardRef as ReactComponent };